import React, { useState } from "react"
import debounce from "lodash.debounce"
import OtpInput from "react-otp-input"
import { useDebounce } from "react-use"

import { InputField } from "./styles"

const OtpField = ({ onSuccess, disabled, error }) => {
  const [otp, setOtp] = useState("")

  const [, cancelDebounce] = useDebounce(
    () => {
      if (otp.length === 6) {
        onSuccess(otp)
      }
    },
    500,
    [otp],
  )

  return (
    <OtpInput
      value={otp}
      onChange={setOtp}
      numInputs={6}
      inputType="number"
      containerStyle={{ display: "flex", justifyContent: "space-between", margin: "3rem 0" }}
      shouldAutoFocus
      renderInput={(props, index) => <InputField {...props} disabled={disabled} error={error} />}
    />
  )
}

export default OtpField
